import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

import { accountsDashboardService } from 'src/services/accounts-dashboard.service'
import { QUERY_KEYS } from 'src/constants'

export const useAccountImpactsLikes = () => {
  const { accountId } = useParams()

  return useQuery(
    [QUERY_KEYS.IMPACTS_LIKES, accountId],
    () => {
      if (!accountId) return null
      return accountsDashboardService.getImpactsLikes(accountId)
    },
    {
      keepPreviousData: true,
    },
  )
}
